// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filterLetters_wrapper__OrtNj","letters-button":"filterLetters_letters-button__OM2QT"};